import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum CryptoDepositAddressesResolverErrorStatesEnum {
    GetCryptoDepositAddressesFailed = ErrorStateScheduleEnum.CryptoDepositAddressesResolverErrorStatesStartIndex
}
